var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LogoutIcon_svg__clip0_451_5998)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5a.75.75 0 01-.75.75H6a.25.25 0 00-.25.25v12a.25.25 0 00.25.25h6a.75.75 0 110 1.5H6A1.75 1.75 0 014.25 18V6A1.75 1.75 0 016 4.25h6a.75.75 0 01.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.388 10.885a1 1 0 011-1h4.856c.023-.356.052-.71.086-1.066l.03-.305a.718.718 0 011.025-.578 16.801 16.801 0 014.885 3.539l.03.03a.72.72 0 010 .999l-.03.03a16.798 16.798 0 01-4.885 3.54.717.717 0 01-1.025-.578l-.03-.305c-.034-.355-.063-.71-.086-1.066H9.388a1 1 0 01-1-1v-2.24z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LogoutIcon_svg__clip0_451_5998"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgLogoutIcon;